import { useContext } from "react";
import { ViewContext } from "./view-provider";

export const useViewContext = () => useContext(ViewContext);

export const useIsEditorContext = () => {
  const { view } = useViewContext();
  return view === "editor";
};
